import { useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";

const jobApplicationsListEndpoint = ApiEndpoints.jobApplication.List;

const tableHeader = ["Date", "Vacancy",  "Vacancy Location", "Name", "last name", "phone", "email",  "DoB", "Gender", "Location", "Monthly Current Salary", "Monthly Expected Salary", "Notice Period", "Total Work Exp In Month", "Total Work Exp In Year", "cover note", "resume"];
const tbody = ["createdAt", "vacancy", "vacancy_location",  "first_name", "last_name", "phone", "email",  "dob", "gender", "location", "monthly_current_salary", "monthly_expacted_salary", "notice_period_in_days", "total_work_exp_in_month", "total_work_exp_in_year", "cover_note", "resume"];

export default function JobApplications() {
  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", jobApplicationsListEndpoint);
      const result = response.jobs;
      setData(result);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    dataFetch();
  }, []);


  const pagename = {
    name: 'Job Applications',
    user: 'Admin',
    innerpage: 'Job Applications'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section contact-manage-tab">
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          showAction={false}
        />
      </div>
    </>
  )
}
